import { System } from "nopun-ecs";

import { TTL } from "../component";

export class TTLSystem extends System {
    static queries = {
        withTTl: [TTL]
    }

    execute(dt: number) {
        for (const entity of this.queries.withTTl.all) {
            const ttl = entity.get(TTL);
            ttl.value -= dt;

            if (ttl.value <= 0) {
                this.scene.entities.destroy(entity);
            }
        }
    }
}